module.exports = "/assets/data/cd0eb0a5ac6f55dda6d0316098d80357-LU4.data.json";